<div class="bg-color py-24 px-3 border-radius-20 main-container mx-auto">

  <!-- Form -->
  <form *ngIf="!isSubmitted" [formGroup]="helpForm" (ngSubmit)="submit()" class="d-flex flex-column gap-16">

    <input type="text" placeholder="Phone Number" formControlName="mobile" maxlength="10" (input)="onlyNumbers($event)"
      class="w-p-100 py-14 px-14 border-radius-12 custom-input color-white ff-Sarabun fw-500 fs-20 line-height-100" />

    <input type="text" placeholder="List the Issue" formControlName="subject" maxlength="120"
      class="w-p-100 py-14 px-14 border-radius-12 custom-input color-white ff-Sarabun fw-500 fs-20 line-height-100" />

    <textarea placeholder="Brief the issue in detail" formControlName="description"
      class="w-p-100 textarea-input py-14 px-14 border-radius-12 custom-input color-white ff-Sarabun fw-500 fs-20 line-height-100">
    </textarea>

    <div class="text-danger fs-16 fw-400 ff-Inter color-crimsonred" *ngIf="apiErrorMessage">
      {{ apiErrorMessage }}
    </div>

    <button type="submit" class="w-p-100 mt-2 border-none border-radius-30 fs-22 ff-Inter py-3 fw-400"
      [disabled]="helpForm.invalid || isSubmitting" [ngClass]="{
        'submit-btn bg-azureblue color-white': helpForm.valid && !isSubmitting,
        'bg-royalblue color-porcelainwhite': helpForm.invalid || isSubmitting
      }">

      {{ isSubmitting ? 'Submitting...' : 'Submit' }}

    </button>

  </form>

  <!-- Success Screen -->
  <div *ngIf="isSubmitted" class="success-container d-flex flex-column align-items-center justify-content-center">

    <mat-icon class="material-symbols-outlined position-relative fs-80 color-azureblue" fontIcon="check_circle">
    </mat-icon>

    <h2 class="color-white ff-Sarabun mb-3 fw-600 fs-32 mt-4">
      Response Submitted
    </h2>

    <p class="color-white ff-Sarabun  fw-600 fs-16 ">
      We will get back to you soon.
    </p>

  </div>

</div>
